import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, } from '@angular/forms'
import { NbDialogRef } from '@nebular/theme';
import { Validators } from 'ngx-editor';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-file-browser-new-folder',
  templateUrl: './file-browser-new-folder.component.html',
  styleUrls: ['./file-browser-new-folder.component.scss']
})
export class FileBrowserNewFolderComponent implements OnInit {
  public loading: boolean;
  public addNewFolder$ = new Subject<string>();
  
  protected formGroup: UntypedFormGroup;
  
  constructor(
    private formBuilder: UntypedFormBuilder,
    private dialogRef: NbDialogRef<FileBrowserNewFolderComponent>
  ) { }

  ngOnInit(): void {
    this.formGroup = this.formBuilder.group({ 
      folderName: this.formBuilder.control('', [ Validators.required(), Validators.minLength(1) ])
    });
  }

  protected cancel(): void {
    this.dialogRef.close();
  }

  protected hasError(name: string): boolean {
    const formControl = this.getFormControl(name);
    return formControl.touched && !formControl.valid;
  }

  protected getFormControl(name: string): UntypedFormControl {
    return this.formGroup.get(name) as UntypedFormControl;
  }

  protected createNewFolder(): void {
    this.loading = true;
    this.addNewFolder$.next(this.formGroup.get('folderName')?.value);
  }
}
